import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

import { useLikeCount, useLikeDelete, useLikeInsert } from 'api/common/like-fetch'

// elements
import IconButton from 'components/elements/IconButton'

import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'

import 'assets/css/dev.css'
/**
 * 좋아요 버튼
 * @param {*} param0
 * @returns
 */
function Like({ seq = 0 }) {
  const { alertModal } = useModal()
  const userInfo = useRecoilValue(userInfoState) // 유저 정보

  const [like, setLike] = useState(0)

  const queryOptions = {
    ntcAtclId: seq,
    regrId: userInfo.userId,
  }

  const likeInsertData = useLikeInsert({
    successHandler: () => {
      setLike(1)
    },
    errorHandler: (error) => {
      alertModal('네트워크 상태를 확인해주세요.')
    },
  })
  const likeDeleteData = useLikeDelete({
    successHandler: () => {
      setLike(0)
    },
    errorHandler: (error) => {
      alertModal('네트워크 상태를 확인해주세요.')
    },
  })

  const { data, isSuccess } = useLikeCount({
    ntcAtclId: seq,
    regrId: userInfo.userId,
  })

  useEffect(() => {
    if (isSuccess) {
      setLike(data?.data)
    }
  }, [data])

  return (
    <IconButton
      type="like"
      size="40"
      className={`border-radius-4 bordered bg-none ${like === 1 ? 'active' : ''}`}
      onClick={() => {
        if (like == 1) {
          likeDeleteData.mutate(queryOptions)
        } else {
          likeInsertData.mutate(queryOptions)
        }
      }}
    />
  )
}

export default Like
